(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$state', '$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($state, $stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.resetAccount = {};
        vm.success = null;
        vm.logout = logout;
        vm.regex = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20})/;
//        vm.regex = '^[_A-Za-z0-9-]*$';

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function logout() {
            Auth.logout();
            $state.go('home');
        }
    }
})();
